import Detail from "../../components/Common/DetailReserv";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Nav, NavItem, NavLink } from "reactstrap";
import Config from "config";
const Detail_reservation = () => {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  const [loading, setLoading] = useState(true);
  const [reservationData, setReservationData] = useState([]);
  const [dossierData, setDossierData] = useState([]);
  const [rompusData, setRompusData] = useState([]);
  const [souscriptionsData, setSouscriptionsData] = useState([]);
  const [activeTab, setActiveTab] = useState("details");
  const token = localStorage.getItem("auth_token_" + api);
  let { id } = useParams();
  const [wait, setWait] = useState(1000);
  const [signature, setSignature] = useState(false);
  const navigate = useNavigate();
  console.log(signature);
  const handleAfterSend = () => {
    toast.success("Envoyé");
  };
  const handleAction = async (action) => {
    console.log(
      `https://www.fluxod.com/${api}/${action?.controller}/${action?.action}?sauvegardes_attestation_id=${action?.params?.sauvegardes_attestation_id}`
    );
    toast.info("Demande en cours...");
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/${action?.controller}/${action?.action}?sauvegardes_attestation_id=${action?.params?.sauvegardes_attestation_id}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.ok) {
        console.log("Request successful");
        const responseData = await response.json();
        toast.success(responseData?.message);
        setSignature(true);
      } else if (response.status === 500) {
        toast.error("Une erreur s'est produite");
      } else {
        console.error("Request failed");
        setSignature(true);
        const responseData = await response.json();
        console.log(responseData.message);
        toast.error(responseData.message);
      }
    } catch (error) {
      console.error("An error occurred", error);
      // toast.error("Une erreur s'est produite");
    }
  };
  const toggleModal = () => {
    // Mettez ici votre logique pour basculer l'état du modal
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };

  const getData = async () => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/reservations_en_cours/${id}/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 403) {
        navigate(`${backUrl}/forbidden`);
      }
      if (response.status === 500) {
        navigate(`${backUrl}/error`);
      }
      if (response.status === 203) {
        navigate(`${backUrl}/error404`);
      }
      if (response.status === 401) {
        localStorage.removeItem("auth_token_" + api);
        localStorage.removeItem("authUser_" + api);
        localStorage.removeItem("sideBar_" + api);
        navigate(`${backUrl}/login`);
        window.location.reload(false);
      }

      // if (!response.ok) {
      //   localStorage.removeItem("auth_token_"+api);
      //   localStorage.removeItem("authUser_"+api);
      //   localStorage.removeItem("sideBar_"+api);
      //   history('/backoffice_test/login');
      //   window.location.reload(false);
      //   throw new Error(`Request failed with status: ${response.status}`);
      // }

      const reservationData = await response.json();
      setReservationData(reservationData);

      {
        reservationData?.hm_accessibles?.map(async (key, index) =>
          key === "hm_dossier_de_souscriptions"
            ? await getDossier()
            : key === "hm_rompus"
            ? await getRompus()
            : key === "hm_souscriptions"
            ? await getSouscriptionHm()
            : null
        );
      }
    } catch (error) {
      // Handle any other errors that might occur during the fetch
      console.error("Error fetching data:", error.message);
    }
  };

  const getDossier = async () => {
    try {
      await fetch(
        `https://www.fluxod.com/${api}/reservations_en_cours/${id}/hm_dossier_de_souscriptions`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setDossierData(data);
          setWait(0);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const getRompus = async () => {
    try {
      await fetch(
        `https://www.fluxod.com/${api}/reservations_en_cours/${id}/hm_rompus`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setRompusData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const getSouscriptionHm = async () => {
    try {
      await fetch(
        `https://www.fluxod.com/${api}/reservations_en_cours/${id}/hm_souscriptions`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setSouscriptionsData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const fetchData = async () => {
    try {
      await getData();
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  if (localStorage.getItem("key") === "true") {
    toast.success("Mise à jour réussie");
    setTimeout(() => {
      localStorage.setItem("key", "false");
    }, 100);
  }

  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={navStyle}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            onClick={() => handleTabClick("details")}
          >
            Détails réservations
          </NavLink>
        </NavItem>

        {reservationData?.hm_accessibles?.map((key, index) =>
          key === "hm_souscriptions" ? (
            <NavItem key={index}>
              <NavLink
                style={navStyle}
                className={`nav-link ${
                  activeTab === "souscriptions" ? "active" : ""
                }`}
                onClick={() => handleTabClick("souscriptions")}
              >
                {!loading ? (
                  souscriptionsData?.title
                ) : (
                  <>
                    <h5 className="card-title placeholder-glow">
                      <span
                        style={{ height: "1em" }}
                        className="placeholder col-6"
                      ></span>
                    </h5>
                  </>
                )}
              </NavLink>
            </NavItem>
          ) : key === "hm_rompus" ? (
            <NavItem key={index}>
              <NavLink
                style={navStyle}
                className={`nav-link ${activeTab === "rompus" ? "active" : ""}`}
                onClick={() => handleTabClick("rompus")}
              >
                {!loading ? (
                  rompusData?.title
                ) : (
                  <>
                    <h5 className="card-title placeholder-glow">
                      <span
                        style={{ height: "1em" }}
                        className="placeholder col-6"
                      ></span>
                    </h5>
                  </>
                )}
              </NavLink>
            </NavItem>
          ) : key === "hm_dossier_de_souscriptions" ? (
            <NavItem key={index}>
              <NavLink
                style={navStyle}
                className={`nav-link ${
                  activeTab === "dossier" ? "active" : ""
                }`}
                onClick={() => handleTabClick("dossier")}
              >
                {!loading ? (
                  dossierData?.title
                ) : (
                  <>
                    <h5 className="card-title placeholder-glow">
                      <span
                        style={{ height: "1em" }}
                        className="placeholder col-6"
                      ></span>
                    </h5>
                  </>
                )}
              </NavLink>
            </NavItem>
          ) : null
        )}
      </Nav>
    );
  };
  return (
    <Detail
      signature={signature}
      Titre={"Dossiers en cours"}
      loading={loading}
      setLoading={setLoading}
      reservationData={reservationData}
      dossierData={dossierData}
      rompusData={rompusData}
      souscriptionsData={souscriptionsData}
      activeTab={activeTab}
      handleAction={handleAction}
      toggleModal={toggleModal}
      handleTabClick={handleTabClick}
      fetchData={fetchData}
      id={id}
      CustomNavTabs={CustomNavTabs}
      api={"reservations_en_cours"}
      wait={wait}
    />
  );
};

export default Detail_reservation;
